/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Loudness_Voice_OverInputs */

const en_audio_description_export_loudness_voice_over = /** @type {(inputs: Audio_Description_Export_Loudness_Voice_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voice Over`)
};

const fr_audio_description_export_loudness_voice_over = /** @type {(inputs: Audio_Description_Export_Loudness_Voice_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voix off`)
};

const de_audio_description_export_loudness_voice_over = /** @type {(inputs: Audio_Description_Export_Loudness_Voice_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voice-Over`)
};

const it_audio_description_export_loudness_voice_over = /** @type {(inputs: Audio_Description_Export_Loudness_Voice_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voce fuori campo`)
};

const ru_audio_description_export_loudness_voice_over = /** @type {(inputs: Audio_Description_Export_Loudness_Voice_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Озвучка`)
};

const es_audio_description_export_loudness_voice_over = /** @type {(inputs: Audio_Description_Export_Loudness_Voice_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voz en off`)
};

const zh_cn2_audio_description_export_loudness_voice_over = /** @type {(inputs: Audio_Description_Export_Loudness_Voice_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`旁白`)
};

const ja_audio_description_export_loudness_voice_over = /** @type {(inputs: Audio_Description_Export_Loudness_Voice_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ナレーション`)
};

const hi_audio_description_export_loudness_voice_over = /** @type {(inputs: Audio_Description_Export_Loudness_Voice_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पार्श्व स्वर`)
};

const pt_pt2_audio_description_export_loudness_voice_over = /** @type {(inputs: Audio_Description_Export_Loudness_Voice_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narração`)
};

/**
* | output |
* | --- |
* | "Voice Over" |
*
* @param {Audio_Description_Export_Loudness_Voice_OverInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_loudness_voice_over = /** @type {((inputs?: Audio_Description_Export_Loudness_Voice_OverInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Loudness_Voice_OverInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_loudness_voice_over(inputs)
	if (locale === "de") return de_audio_description_export_loudness_voice_over(inputs)
	if (locale === "it") return it_audio_description_export_loudness_voice_over(inputs)
	if (locale === "ru") return ru_audio_description_export_loudness_voice_over(inputs)
	if (locale === "es") return es_audio_description_export_loudness_voice_over(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_loudness_voice_over(inputs)
	if (locale === "ja") return ja_audio_description_export_loudness_voice_over(inputs)
	if (locale === "hi") return hi_audio_description_export_loudness_voice_over(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_loudness_voice_over(inputs)
	return en_audio_description_export_loudness_voice_over(inputs)
});